// extracted by mini-css-extract-plugin
export default {"base":"BarChartDisplay_base__APvHY","select":"BarChartDisplay_select__o-gmq"};